import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {CalendarViewType} from "@model";

export const LANG = "LANG";
export const JWT_RESPONSE = "JWT_RESPONSE";
export const PREFERRED_LAYOUT = "PREFERRED_LAYOUT";

@Injectable({ providedIn: 'root' })
export class LocalStorageService {


  private _currentLayout = new BehaviorSubject<CalendarViewType>(
      this.getLayoutFromStorage() ?? CalendarViewType.LIST
  );

  readonly currentLayout$ = this._currentLayout.asObservable();

  get currentLayout(): CalendarViewType {
    return this._currentLayout.getValue();
  }

  setLayout(layout: CalendarViewType): void {
    this.saveData(PREFERRED_LAYOUT, layout.toString());
    this._currentLayout.next(layout);
  }

  private getLayoutFromStorage(): CalendarViewType | null {
    const saved = this.getData(PREFERRED_LAYOUT);
    return saved ? Number(saved) as CalendarViewType : null;
  }


  saveData(key: string, value: string) {
    if (typeof window !== 'undefined') {
      localStorage.setItem(key, value);
    }
  }

  public getData(key: string) {
    if (typeof window !== 'undefined') {
      return localStorage.getItem(key);
    } else {
      return undefined;
    }
  }

  removeData(key: string) {
    if (typeof window !== 'undefined') {
      localStorage.removeItem(key);
    }
  }

  clearData() {
    if (typeof window !== 'undefined') {
      localStorage.clear();
    }
  }

  getAllKeys(): string[] {
    if (typeof window === 'undefined') return [];
    const keys: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key) keys.push(key);
    }
    return keys;
  }

}
